import { Link } from 'react-router-dom';
import { useAuth } from '../../store/AuthContext';
import { PageHeader } from '../../components/ui/index';
import { isEmployee } from '../../utils/roleHelpers';
import {
  ListBullets, ClipboardText, ArrowsClockwise, ArrowsLeftRight, PhoneCall,
  Star, MapPin, MapTrifold, Buildings, Handshake,   Signature, User, ShieldCheck, Hash, BellRinging, Robot, ChatText, UsersThree,
} from '@phosphor-icons/react';

const SETTING_ICONS = {
  'menu-order': ListBullets,
  'report-items': ClipboardText,
  'auto-referral': ArrowsClockwise,
  'cross-referral': ArrowsLeftRight,
  voip: PhoneCall,
  ratings: Star,
  'gps-places': MapPin,
  'gps-report': MapTrifold,
  'company-permissions': Buildings,
  delegation: Handshake,
  'task-members': UsersThree,
  signature: Signature,
  profile: User,
  'access-control': ShieldCheck,
  'username-prefix': Hash,
  'error-alerts': BellRinging,
  'ai-services': Robot,
  'sms-campaigns': ChatText,
};

const ALL = 'all';

function buildSettingItems(userType) {
  const items = [
    {
      icon: 'menu-order',
      title: 'ترتیب منو',
      desc: 'جابه‌جایی و مخفی‌کردن آیتم‌های منوی کناری',
      to: '/settings/menu',
      roles: ALL,
    },
    {
      icon: 'report-items',
      title: 'بخش‌های گزارش روزانه',
      desc: 'تعریف فیلدهایی که کارمندان هنگام پر کردن گزارش روزانه می‌بینند',
      to: '/settings/daily-report-items',
      roles: ['manager_employee', 'admin'],
    },
    {
      icon: 'auto-referral',
      title: 'ارجاع خودکار تیکت',
      desc: 'قوانین ارجاع خودکار تیکت به کارمندان دپارتمان بر اساس شرکت، فرستنده، محتوا یا زمان',
      to: '/settings/auto-referral',
      roles: ['manager_employee', 'admin'],
    },
    {
      icon: 'cross-referral',
      title: 'ارجاع بین دپارتمان‌ها',
      desc: 'تعیین اینکه مدیران کدام دپارتمان‌ها به هم ارجاع دهند و کارمندان کدام دپارتمان بتوانند به دپارتمان دیگر ارجاع دهند',
      to: '/settings/cross-referral',
      roles: ['admin'],
    },
    {
      icon: 'voip',
      title: 'ترانک‌های VoIP',
      desc: 'مشخص کردن اینکه هر ترانک آسیریسک متعلق به کدام شرکت است، برای نمایش نام تماس‌گیرنده در پاپ‌آپ تماس ورودی',
      to: '/settings/voip-trunks',
      roles: ['admin'],
    },
    {
      icon: 'gps-places',
      title: 'مکان‌های مجاز GPS',
      desc: 'تعریف دفتر مرکزی و سایت‌های مشتری برای بررسی حضور کارمند در گزارش موقعیت مکانی',
      to: '/settings/gps-known-places',
      roles: ['manager_employee', 'admin'],
    },
    {
      icon: 'gps-report',
      title: 'گزارش موقعیت مکانی کارمندان',
      desc: 'مسیر حرکت روزانه هر کارمند و مطابقت آن با مکان‌های مجاز',
      to: '/reports/gps-daily-report',
      roles: ['manager_employee', 'admin'],
    },
    {
      icon: 'company-permissions',
      title: 'دسترسی تعریف شرکت و کاربر',
      desc: 'مشخص کنید مدیر کدام دپارتمان‌ها اجازه تعریف شرکت/کاربر جدید دارد و کدام‌یک می‌تواند این اجازه را به کارمندانش واگذار کند',
      to: '/settings/manager-company-permissions',
      roles: ['admin', 'dispatcher'],
    },
    {
      icon: 'username-prefix',
      title: 'جداکننده نام کاربری',
      desc: 'انتخاب _ یا - بین نام شرکت و نام کاربری هنگام ساخت کاربر',
      to: '/settings/username-prefix',
      roles: ['admin', 'dispatcher'],
    },
    {
      icon: 'error-alerts',
      title: 'پیامک خطای سرور',
      desc: 'فعال یا غیرفعال کردن پیامک خودکار به ادمین هنگام بروز خطا در برنامه',
      to: '/settings/error-alerts',
      roles: ['admin'],
    },
    {
      icon: 'sms-campaigns',
      title: 'کمپین پیامکی',
      desc: 'تعریف قالب پیامک و ارسال به کاربران یا کارمندان بر اساس شرکت، دپارتمان یا فرد مشخص',
      to: '/sms-campaigns',
      roles: ['dispatcher', 'admin'],
    },
    {
      icon: 'ai-services',
      title: 'سرویس‌های هوش مصنوعی',
      desc: 'مشاهده وضعیت و تست سرویس‌های خلاصه‌ساز، مدل زبانی و مسیریابی تیکت - ریستارت فقط برای ادمین',
      to: '/settings/ai-services',
      roles: ['dispatcher', 'admin'],
    },
    {
      icon: 'access-control',
      title: 'کنترل دسترسی گزارشات',
      desc: 'تعیین اینکه علاوه بر ادمین، کدام نقش‌ها اجازه مشاهده هر گزارش را دارند',
      to: '/settings/access-control',
      roles: ['admin'],
    },
    {
      icon: 'task-members',
      title: 'کارمندان قابل تعریف تسک',
      desc: 'افزودن کارمندان سایر دپارتمان‌ها تا بتوانید برای آن‌ها هم تسک تعریف کنید',
      to: '/settings/task-members',
      roles: ['manager_employee'],
    },
    {
      icon: 'delegation',
      title: 'واگذاری دسترسی تعریف شرکت/کاربر',
      desc: 'در صورت داشتن اجازه از دیسپچر، این دسترسی را به کارمندان دپارتمان خود بدهید',
      to: '/settings/company-delegation',
      roles: ['manager_employee', 'admin'],
    },
    {
      icon: 'signature',
      title: 'امضای تصویری',
      desc: 'رسم و ذخیره امضا برای فرم‌های چاپ گزارش',
      to: '/settings/signature',
      roles: ALL,
    },
    {
      icon: 'profile',
      title: 'ویرایش پروفایل',
      desc: 'نام، اطلاعات تماس و رمز عبور',
      to: '/profile/edit',
      roles: ALL,
    },
  ];

  return items.filter((item) => {
    if (item.roles === ALL) return true;
    return item.roles.includes(userType);
  });
}

export default function SettingsPage() {
  const { user } = useAuth();
  const settingItems = buildSettingItems(user?.type);

  return (
    <div className="fade-in">
      <PageHeader title="تنظیمات" subtitle="پیکربندی رابط کاربری و حساب کاربری" />
      <div style={{ maxWidth: 560, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {settingItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            style={{
              background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0',
              padding: '18px 20px', display: 'flex', gap: 14, alignItems: 'center',
              textDecoration: 'none', transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#B7C9EC';
              e.currentTarget.style.boxShadow = '0 2px 12px rgba(35,58,122,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#e2e8f0';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <span style={{
              width: 44, height: 44, background: '#f8faff', color: '#233A7A',
              borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}
            >
              {(() => { const Icon = SETTING_ICONS[item.icon] || ClipboardText; return <Icon size={22} weight="regular" />; })()}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>{item.title}</div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 3 }}>{item.desc}</div>
            </div>
            <span style={{ color: '#94a3b8', fontSize: 20 }}>›</span>
          </Link>
        ))}

        {isEmployee(user?.type) && (
          <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 8, lineHeight: 1.7 }}>
            برای تغییر ترتیب منوی کناری، «ترتیب منو» را باز کنید. اگر «تنظیمات» در منو را نمی‌بینید، احتمالاً قبلاً مخفی شده — از همان صفحه می‌توانید دوباره نمایشش دهید.
          </p>
        )}
      </div>
    </div>
  );
}
